import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export function shareReplaySafe<TOut>(bufferSize?: number) {
  return (observable: Observable<TOut>) =>
    observable.pipe(shareReplay({ bufferSize, refCount: true }));
}
